export default __webpack_public_path__ + "static/media/2474.384d3168.png";